import { render, staticRenderFns } from "./share.vue?vue&type=template&id=2d0801bb&scoped=true&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style0 from "./share.vue?vue&type=style&index=0&id=2d0801bb&prod&lang=scss&"
import style1 from "./share.vue?vue&type=style&index=1&id=2d0801bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0801bb",
  null
  
)

export default component.exports